/**
 * Transaction Split Modal Component
 * 
 * Modal for splitting transactions across multiple categories
 */

import React from 'react';
import { Transaction } from '../../types/transaction.types';
import { X } from 'lucide-react';

interface TransactionSplitModalProps {
  transaction: Transaction;
  onClose: () => void;
  onSave: () => void;
}

export function TransactionSplitModal({
  transaction: _transaction,
  onClose,
  onSave: _onSave
}: TransactionSplitModalProps): React.ReactElement {
  // Placeholder - to be implemented
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-xl max-w-2xl w-full max-h-[90vh] overflow-hidden">
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
              Split Transaction
            </h2>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
              aria-label="Close modal"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
        <div className="p-6">
          <p className="text-gray-600 dark:text-gray-400">
            Transaction split functionality coming soon...
          </p>
        </div>
      </div>
    </div>
  );
}

